const prefix = 'AUTH/';
const AUTHENTICATED_USER = `${prefix}AUTHENTICATED_USER`;

export const VERIFY_TOKEN_TAG = `${prefix}VERIFY_TOKEN`;
export const START_SYNC_WITH_APP_TAG = `${prefix}START_SYNC_WITH_APP`;

export default AUTHENTICATED_USER;
